export default __webpack_public_path__ + "3044f87f03dc4a39668ad972f4a90af8.jpg";